import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";

import { sizes, date } from "../../../constants/common";

import { displayData } from "../../../utils/data";
import { formatDate } from "../../../utils/date";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const MdcCard3 = (props) => {
  const { data } = props;

  const dataTypes = [
    {
      id: "tailgate",
      name: I18n.get("dashboard_tailgates"),
      icon: images.tailgatingIconGrey,
    },
    {
      id: "averagetimeatgate",
      name: I18n.get("dashboard_averageTimeAtGate"),
      icon: images.averageTimeGateIcon,
      dataType: date,
    },
  ];

  return (
    <DashboardCard
      size={sizes.xsmall}
      style={{
        minWidth: "245px",
        flexGrow: 1,
        margin: "12px",
      }}
    >
      <Grid
        container
        direction="column"
        style={{ height: "100%", width: "200px", margin: "auto" }}
        wrap="nowrap"
      >
        {map(dataTypes, (type) => (
          <React.Fragment key={type.id}>
            <Grid
              item
              className="text-87 bold-500"
              style={{ marginTop: "10px" }}
            >
              {get(type, ["name"])}
            </Grid>
            <Grid container alignItems="center" wrap="nowrap">
              <Grid
                item
                className="flexCenter"
                style={{
                  justifyContent: "center",
                  height: "40px",
                  width: "70px",
                  marginRight: "20px",
                }}
              >
                <img
                  src={get(type, ["icon"])}
                  alt={type.id}
                  style={{ maxHeight: "40px", width: "70px" }}
                />
              </Grid>
              <Grid
                item
                style={{
                  fontWeight: 500,
                  fontSize: "2em",
                  lineHeight: "30px",
                  //color: colors.primary,
                  color: colors.black87,
                  textAlign: "center",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                {get(type, ["dataType"]) === date ? (
                  get(data, ["card3", type.id]) ? (
                    formatDate(
                      get(data, ["card3", type.id]) * 1000,
                      "m[m] ss[s]"
                    )
                  ) : (
                    <span className="text-87 bold-500">-</span>
                  )
                ) : (
                  displayData(get(data, ["card3", type.id]))
                )}
              </Grid>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </DashboardCard>
  );
};

export default MdcCard3;
